// extracted by mini-css-extract-plugin
module.exports = {"bgBody":"style_bgBody__1DcER","btnHome":"style_btnHome__3kZTv","container":"style_container__1z6RQ","card":"style_card__3EWf6","section":"style_section__1BqOd"};